import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const LogoCarousal = ({ data }) => {
  console.info(data);
  return (
    <section class=" text-white text-center m-auto w-8/12 mb-5">
      <div className="w-full inline-flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
        <ul className="flex items-center justify-center md:justify-start [&_li]:mx-8  [&_img]:min-w-32 [&_img]:max-w-32 animate-infinite-scroll">
          {data.LogoCarousel.map((item, index) => {
            console.info(item.Link);
            const image = getImage(item.Logo?.localFile);
            const withHttp = (url) =>
              !/^https?:\/\//i.test(url) ? `http://${url}` : url;
            const myUrl = withHttp(item.Link);
            return item.Link !== null ? (
              <li key={index}>
                <a
                  href={`${myUrl}`}
                  target={item.OpenSameTab ? "_self" : "_blank"}
                >
                  <GatsbyImage image={image} alt="image" />
                </a>
              </li>
            ) : (
              <li key={index}>
                <GatsbyImage image={image} alt="image" />
              </li>
            );
          })}
        </ul>

        <ul
          className="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:min-w-32 [&_img]:max-w-32 animate-infinite-scroll"
          aria-hidden="true"
        >
          {data.LogoCarousel.map((item, index) => {
            const image = getImage(item.Logo?.localFile);

            return item.Link !== null ? (
              <li key={index}>
                <a
                  href={`//${item.Link}`}
                  target={item.OpenSameTab ? "_self" : "_blank"}
                >
                  <GatsbyImage image={image} alt="image" />
                </a>
              </li>
            ) : (
              <li key={index}>
                <GatsbyImage image={image} alt="image" />
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default LogoCarousal;
